<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead :title="'Provider Based Reservations'"></cardHead>
          <div>
            <Form
              method="dialog"
              v-slot="{ errors }"
              class="floating-labels row  p-20 p-b-10"
              ref="form"
            >
              <div class="col">
                <formGroup
                  :title="'StartDate'"
                  :type="'date'"
                  :max="model.EndDate"
                  v-model="model.StartDate"
                  :errors="errors"
                  @keydown.enter="get"
                ></formGroup>
              </div>
              <div class="col">
                <formGroup
                  :title="'EndDate'"
                  :type="'date'"
                  :min="model.StartDate"
                  v-model="model.EndDate"
                  :errors="errors"
                  @keydown.enter="get"
                ></formGroup>
              </div>
              <div class="col-auto">
                <Btn
                  class="btn-success"
                  @click="get()"
                  :disabled="reportProcess"
                  :process="reportProcess"
                  >Get</Btn
                >
              </div>
            </Form>
            <dataTable
              :name="'ProviderBasedReservations'"
              v-if="data != null && !reportProcess"
              ref="agGrid"
              :columnDefs="columnDefs"
              :data="data"
              @cellClicked="openDetail = { ...$event.data }"
            ></dataTable>
            <load-area v-if="reportProcess" class="border-top"></load-area>
          </div>
        </div>
      </div>
    </div>
  </div>
  <detail
    v-if="openDetail != null"
    :detail="openDetail"
    @close="openDetail = null"
  ></detail>
</template>

<script>
import detail from "./detail.vue";
export default {
  name: "ProviderBasedReservations",
  components: { detail },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          field: "ProviderId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 60,
        },
        {
          headerName: "Name",
          field: "ProviderName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "New",
          field: "New",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "Changed",
          field: "Changed",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "Cancelled",
          field: "Cancelled",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "Booked",
          field: "Booked",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "Other",
          field: "Other",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "Total",
          field: "Total",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
      ],
      data: null,
      model: {
        StartDate: null,
        EndDate: null,
      },
      reportProcess: false,
      openDetail: null,
    };
  },
  created() {
    this.model.StartDate = this.$moment(
      new Date().setDate(new Date().getDate() - 10)
    ).format("YYYY-MM-DD");
    this.model.EndDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.reportProcess = true;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reports/ProviderBasedReservations`, this.model)
        .then((response) => {
          this.data = response.data.sort((x, y) => {
            return y.Total - x.Total;
          });
          this.reportProcess = false;
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
          this.data = [];
          this.reportProcess = false;
        });
    },
    reload() {
      this.get();
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
